// Speech to Text

import { type MicVAD } from "@ricky0123/vad-web"
import tts from '@/components/Chat/TTS';
import prefs from '@/controllers/preferences'
import * as stt_settings from '@/controllers/stt_settings'

function playAudio(audio: Float32Array) {
    const audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    const buffer = audioCtx.createBuffer(1, audio.length, 16000);
    buffer.getChannelData(0).set(audio);
    const source = audioCtx.createBufferSource();
    source.buffer = buffer;
    source.connect(audioCtx.destination);
    source.start();
}


export const state = {
    langcode: 'en'
}

// Converts Float32Array audio to a WAV file Blob (16-bit PCM, mono, 16kHz)
export function audioToWavBlob(audio: Float32Array): Blob {
    const sampleRate = 16000;
    const numChannels = 1;
    const bufferLength = audio.length;
    const bytesPerSample = 2; // 16-bit PCM

    // WAV header size: 44 bytes
    const wavBuffer = new ArrayBuffer(44 + bufferLength * bytesPerSample);
    const view = new DataView(wavBuffer);

    // RIFF chunk descriptor
    writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + bufferLength * bytesPerSample, true); // file length - 8
    writeString(view, 8, "WAVE");

    // fmt subchunk
    writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true); // Subchunk1Size (16 for PCM)
    view.setUint16(20, 1, true); // AudioFormat (1 for PCM)
    view.setUint16(22, numChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * numChannels * bytesPerSample, true); // ByteRate
    view.setUint16(32, numChannels * bytesPerSample, true); // BlockAlign
    view.setUint16(34, 8 * bytesPerSample, true); // BitsPerSample

    // data subchunk
    writeString(view, 36, "data");
    view.setUint32(40, bufferLength * bytesPerSample, true);

    // Write PCM samples
    for (let i = 0; i < bufferLength; i++) {
        // Clamp and convert float [-1,1] to 16-bit PCM
        let sample = Math.max(-1, Math.min(1, audio[i]));
        sample = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
        view.setInt16(44 + i * bytesPerSample, sample, true);
    }

    return new Blob([wavBuffer], { type: "audio/wav" });
}

export function blobToBase64(blob: Blob): Promise<string> {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise(resolve => {
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
  });
};


function writeString(view: DataView, offset: number, str: string) {
    for (let i = 0; i < str.length; i++) {
        view.setUint8(offset + i, str.charCodeAt(i));
    }
}

class STT {
    enabled = false;
    vad: MicVAD | null = null;
    stream: MediaStream | null = null;
    onSpeechEnd: ((audio: Float32Array) => void) = (_) => {};

    async start() {
        tts.enable();
        this.enabled = true;

        // this.stream = await navigator.mediaDevices.getUserMedia({
        //     audio: {
        //         echoCancellation: true,
        //     },
        // });

        const MicVAD = await import("@ricky0123/vad-web");
        const saved_settings = await stt_settings.get();
        this.vad = await MicVAD.MicVAD.new({
            baseAssetPath: "/vad/", // or whatever you want
            onnxWASMBasePath: "/vad/", // or whatever you want
            onSpeechEnd: (audio) => {
                console.log("Speech end");
                this.onSpeechEnd(audio);
                // Play the audio (Float32Array) using Web Audio API
                //playAudio(audio); // debug
            },
            positiveSpeechThreshold: saved_settings.positiveSpeechThreshold,
            negativeSpeechThreshold: saved_settings.negativeSpeechThreshold,
            redemptionFrames: saved_settings.redemptionFrames,
            model: "v5",
            //frameSamples: 1536,
            minSpeechFrames: saved_settings.minSpeechFrames
            //stream: this.stream,
        });
        this.vad.start()
    }

    pause() {
        this.vad?.pause()
    }

    resume() {
        this.vad?.start();
    }

    stop() {
        tts.disable();
        this.enabled = false;

        this.vad?.destroy();
        // this.stream?.getTracks().forEach(track => track.stop());
        // this.stream = null;
    }
}

export const globalSTT = new STT();

const load = async () => {
    // if (tts.state.enabled) {
    //     globalSTT.start();
    // } else {
    //     globalSTT.stop();
    // }
}
load()

export default { globalSTT, state }